import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "../assets/css/Responsive.css";

import Home from "../containers/Home";

import Curso from "../containers/Curso";
import Plan from "../containers/Plan";
import Escuela from "../containers/Escuela";
import Layout from "../components/Layout";
import UsarContexto from "../context/UsarContexto";
import MisCursos from "../containers/MisCursos";
import Examenes from "../containers/Examenes";
import MiPerfil from "../containers/MiPerfil";
import Comprar from "../containers/Comprar";
import "../assets/css/App.css";
import Ofertas from "../containers/Ofertas.js";
import Restablecer from "../containers/Restablecer.jsx";
import P404 from "../containers/P404.js";
import Ver from "../containers/Ver.js";
import Renovaciones from "../containers/Renovaciones";
import Gratis from "../containers/Gratis";
import Faq from "../containers/Faquestion";
import Certificados from "../containers/Certificados";
import Podcast from "../containers/Podcast";
import DesignSeason from "../containers/DesignSeason";
import Leeme from "../components/Leeme";
import AnvorGame from "../containers/AnvorGame";
import SummerHack from "../containers/WinterHack";
import Regalo from "../containers/Regalo";
import DGFsbGVyZXNhY29sb3I from "../containers/DGFsbGVyZXNhY29sb3I";
import Paneldecontrol from "../containers/Paneldecontrol";
import Gracias from "../containers/Gracias";

function App() {
  return (
    <Router>
      <UsarContexto>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="/paneldecontrol" element={<Paneldecontrol />}></Route>
            <Route path="/home" element={<Home />}></Route>
            <Route exact path="/curso/" element={<Curso />}></Route>
            <Route exact path="/gracias" element={<Gracias />}></Route>
            <Route exact path="/plan/" element={<Plan />}></Route>
            <Route exact path="/regalo" element={<Regalo />}></Route>
            <Route path="/escuela/*" element={<Escuela />}></Route>
            <Route exact path="/miscursos/" element={<MisCursos />}></Route>
            <Route exact path="/restablecer/" element={<Restablecer />}></Route>
            <Route exact path="/examenes/*" element={<Examenes />}></Route>
            <Route exact path="/MiPerfil/" element={<MiPerfil />}></Route>
            <Route path="/comprar/*" element={<Comprar />}></Route>
            <Route exact path="/ofertas/" element={<Ofertas />}></Route>
            <Route exact path="/gratis/" element={<Gratis />}></Route>
            <Route exact path="/podcast/" element={<Podcast />}></Route>
            <Route path="/certificados/*" element={<Certificados />}></Route>
            <Route exact path="/faq/" element={<Faq />}></Route>
            <Route exact path="/ver/" element={<Ver />}></Route>
            <Route exact path="/leer/" element={<Leeme />}></Route>
            <Route exact path="/summerhack/" element={<SummerHack />}></Route>
            <Route exact path="/anvorgame" element={<AnvorGame />}></Route>
            <Route
              exact
              path="/DGFsbGVyZXNhY29sb3I"
              element={<DGFsbGVyZXNhY29sb3I />}
            ></Route>

            <Route exact path="/404/" element={<P404 />}></Route>
            <Route path="/ver/*" element={<Ver />}></Route>
            <Route
              exact
              path="/renovaciones"
              element={<Renovaciones />}
            ></Route>
            <Route path="*" element={<Curso />}></Route>
          </Routes>
        </Layout>
      </UsarContexto>
    </Router>
  );
}

export default App;
